export default "/images/865ac827b17daa5ea03a7664188da640.avif";